// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AtualizaFormasPagamentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /contas/atualiza_formas_pagamento/{conta_id}
 *
 * Updates the payment methods associated with an account.
 */
import { registerContract } from './validate'

export interface Contas_AtualizaFormasPagamentoInput {
formas_pagamento_ids: number[]
}

registerContract('Contas_AtualizaFormasPagamentoInput', {
  formas_pagamento_ids: { type: 'array',   required: true },
})
